import Vue from "vue";

import VueCompositionAPI from "@vue/composition-api";
Vue.use(VueCompositionAPI);

import { init as initSentry } from "@sentry/vue";
// import { Integrations } from "@sentry/tracing";

initSentry({
  Vue,
  dsn:
    "https://c6de590efb0b46168a2585cb895d9cc6@o515301.ingest.sentry.io/5619886",
  //   integrations: [new Integrations.BrowserTracing()],
  environment: process.env.NODE_ENV,
  autoSessionTracking: false,

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
  logErrors: process.env.NODE_ENV != "production",
});

import App from "./App";
import { flash } from "./boot/functions";
import router from "./router";
import store from "./store";

require("./boot/plugins");
require("./boot/axios");
require("./boot/polyfill");

/**
 * Let's use some flash notifications
 */
window.events = new Vue();

// should not be used, import them (see above)
window.flash = flash;

Vue.component(
  "ranch-credit",
  require("./components/Design/Icons/RanchCredit").default
);
Vue.component("ranch-button", require("./components/Design/Button").default);
Vue.component("alert", require("./components/Design/Alert").default);
Vue.component("loading", require("./components/Design/Loading").default);
Vue.component(
  "saving-overlay",
  require("./components/Design/Forms/SavingOverlay").default
);
Vue.component("safe-warning", require("./components/SafeWarning").default);
Vue.component("text-copier", require("./components/Design/TextCopier").default);
Vue.component(
  "simple-label",
  require("./components/Design/Forms/SimpleLabel").default
);
Vue.component(
  "drag-overlay",
  require("./components/Design/DragOverlay").default
);
Vue.component("clock", require("./components/Design/Clock").default);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
